export const MFE_PATHS = {
  INVOICING: '/invoicing',
  MONEY_INVOICING: '/money/invoices',
  MONEY_TAX_SERVICES: '/money/tax-services'
};
